import { useRef } from "react";
import styles from "./AccordionItem.module.css";
import { useEffect } from "react";

function AccordionItem({
    title,
    description,
    id,
    setCurrentIndex,
    currentIndex,
    index,
}) {
    const ref = useRef(null);

    function handleActivateItem() {
        if (currentIndex === index) {
            setCurrentIndex(-1);
        } else {
            setCurrentIndex(index);
        }
    }

    function handleHeadingKey(event) {
        if (event.keyCode === 13 || event.keyCode === 32) {
            event.preventDefault();
            handleActivateItem();
        }
    }

    function setMaxHeightProperty() {
        const newHeight = ref.current
            .querySelector(`.${CSS.escape(styles.answer)}`)
            ?.getBoundingClientRect().height;

        ref.current.style.setProperty("--max-height", `${newHeight}px`);
    }

    useEffect(() => {
        setMaxHeightProperty();
    }, []);

    return (
        <div
            className={[
                styles.accordion_item,
                index === currentIndex ? styles.open : "",
            ].join(" ")}
            id={id}
            ref={ref}
        >
            <div
                tabIndex={0}
                onClick={handleActivateItem}
                onKeyDown={handleHeadingKey}
                role="heading"
                aria-level={3}
                className={styles.heading_wrapper}
            >
                <div
                    id={id + "-button"}
                    className={styles.heading_text}
                    role="button"
                    aria-expanded={false}
                    aria-controls={id + "-panel"}
                >
                    <strong>{title}</strong>
                    <img
                        className={styles.arrow_image}
                        src="/arrow-down-icon.svg"
                        alt=""
                    />
                </div>
            </div>
            <div
                className={styles.body_container}
                id={id + "-panel"}
                role="region"
                aria-labelledby={id + "-button"}
            >
                <p
                    className={styles.answer}
                    dangerouslySetInnerHTML={{ __html: description }}
                ></p>
            </div>
        </div>
    );
}

export default AccordionItem;
